import React from "react";

const Newsletters = () => {
  return <div className="newsletters">newsletters</div>;
};

export default Newsletters;
